export default __webpack_public_path__ + "static/media/IBANK.79882179.png";